<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-6 customHeading">
          <h3>{{moduleName}}</h3>
        </div>

        <!--==========Class dropdown============-->
      <div class="col-md-2">
        
      </div>

        <!---SEARCH BOX-->
         <div class="col-md-3">
          <div class="searchbox input-group" role="group">
          <input class="form-control search-box my-search-box" type="text" placeholder="Name" aria-label="search" v-model="filteredText">
         
          <button class="search-button btn btn-primary filter"  @click="getFlourWeightLinks()"><i class="fa fa-search search-icon"></i></button>
          </div>
          
        </div>
        <div class="col-md-1 Add-button" style="text-align:center">
          <a href="javascript:void(0)">
            <div class="AddButton">
              <div class="icon">
                <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
                </i>
              </div>
              <div data-text="Add" class="name add-btn" v-b-modal.AddFlourTypeWeightLinkModal>Add </div>
            </div>
          </a>
        </div> 


        <!--
        <div class="col-md-6"><div class="icons_group"><div class="row w3-center"><div class="col-md-2"><a href="#filterSection" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="filterSection"><div class="icon"><i class="fas fa-align-center fa-1x" style="color: rgb(243, 0, 104);"></i></div> <div data-text="Filter" class="name">Filter</div></a></div> <div class="col-md-3"><a href="#"><div class="icon"><i class="fas fa-check-circle fa-1x" style="color: rgb(149, 171, 184);"></i></div> <div data-text="Anti-Spam" class="name">Anti-Spam</div></a></div> <div class="col-md-3"><a href="#"><div class="icon"><i class="fas fa-stream fa-1x" style="color: rgb(255, 143, 38);"></i></div> <div data-target="Autoresponder" class="name">
                                  Auto-responder
        </div></a></div> <div class="col-md-2"><a href="#"><div class="icon"><i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);"></i></div> <div data-text="Forward" class="name">Forward</div></a></div> <div class="col-md-2"><a href="#"><div class="icon"><i class="fas fa-trash fa-1x" style="color: rgb(195, 0, 0);"></i></div> <div data-text="delete" class="name">Delete</div></a></div></div></div></div>
       
       --> 
       </div>
       <div class="row">
         <div class="col">
          <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
         </div>
        </div>
      <div>
        <div class="row"><div class="col">
        <table class="table table-striped table-borderless cutom-table table-striped table-sm" 
          style="font-size: 85%;">
            <thead>
              <tr>
             
                <th role="columnheader">Flour Type</th>
                 <th role="columnheader">Flour Weight</th>
                <th role="columnheader" >Actions</th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if= "weights==null" >
                <td class = "center-td" colspan="3">No Data</td>
              </tr>
              
            <tr v-else v-for="type in weights" :key=type.id>
              <td  role="cell">
        
                {{type.flourType.name}}
             
              </td>
                <td  role="cell">
        
                {{type.flourWeight.weight}}
             
                </td>
           
         
              <td>
               
                <span @click= "passRecordToDelete(type.id)">
                  <i role="button" style="color:green" class="far fa-trash-alt"></i>
                </span>
              
              </td>
            </tr>
          </tbody>
        </table>
      </div></div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getFlourWeightLinks()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
            <b-pagination
              v-model= "page"
              :total-rows= rows
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
      </div>

       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
      <AddFlourTypeWeightLinkModal/>
    <DeleteModal :msgForModal= "msgForModal" :apiEndPoint = "apiEndPoint" :heading = "deleteModalHeading"  :entityId = "typeToDelete"/>
   
   
     
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import AddFlourTypeWeightLinkModal from './modals/AddFlourTypeWeightLinkModal'
import DeleteModal from '../../modals/DeleteModal'


export default {
    name: 'ManageFlourTypes',
    data(){
        return{
          moduleName:'Manage Flour Types',
          Id:null,
          isLoading:false,
          typeToDelete:null,
          msgForModal:null,
          apiEndPoint:null,
          deleteModalHeading:null,

             
          weights:null,
        
          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25     
		}
  },
 
methods:{


    getPage(page)
  {
    this.page = page;
    this.getFlourWeightLinks();
  },
  
  passRecordToDelete(id)
  {
    this.typeToDelete = id;
    this.msgForModal = "Confirm to delete !";
    this.apiEndPoint = "flourweighttypelink/Delete/";
    this.deleteModalHeading = "Delete"
    this.$bvModal.show('DeleteModal')

  },
 
    
   

    getFlourWeightLinks(){
       this.isLoading = true;
      axios.post('/FlourWeightTypeLink/getall',{"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page,"Text":this.filteredText})
    .then(res=>{
      this. isLoading = false;

      if(res.data.status == 1)
      {
        console.log(res.data)
        this.weights=res.data.data;
        this.rows = res.data.totalRecords;
      }
      else if(res.data.status== -1)
      {
          this.$bvModal.msgBoxOk(res.data.msg, {
          title: 'Error!',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          headerClass: 'p-10 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
          });
      }
      else {
        this.weights = null;
      }
    });
    },
		
   

  search(){
   
    this.page=this.pageNumOnSearch;
    this.getFlourWeightLinks();
  }
  },
	created(){
    this.getFlourWeightLinks();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components:{
    Spinner,
    AddFlourTypeWeightLinkModal,
    DeleteModal,
  
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}
.col{
  padding-left:0px;
  padding-right:0px;
}
</style>